import { render, staticRenderFns } from "./CamposAdicionaisSetting.vue?vue&type=template&id=409f508c"
import script from "./CamposAdicionaisSetting.vue?vue&type=script&lang=js"
export * from "./CamposAdicionaisSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports